import script from "./events.vue?vue&type=script&setup=true&lang=js"
export * from "./events.vue?vue&type=script&setup=true&lang=js"

import "./events.vue?vue&type=style&index=0&id=714c446a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714c446a"]])

export default __exports__